import React from 'react'

interface MiniWaveChartProps {
  progress?: number
  className?: string
}

export const MiniWaveChart: React.FC<MiniWaveChartProps> = ({ progress = 0.08, className }) => {
  const clampedProgress = Math.min(0.22, Math.max(0.05, progress))
  const segmentLength = clampedProgress * 100
  const arcPath = 'M 14 124 A 79 79 0 0 1 171 124'

  return (
    <div className={`absolute right-0 top-0 h-[124px] w-[185px] overflow-clip ${className || ''}`}>
      <svg className="h-full w-full" viewBox="0 0 185 124" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d={arcPath} pathLength={100} stroke="rgba(197,204,159,0.34)" strokeWidth="8" strokeLinecap="round" fill="none" />
        <path
          d={arcPath}
          pathLength={100}
          stroke="#c8ed03"
          strokeWidth="8"
          strokeLinecap="round"
          fill="none"
          strokeDasharray={`${segmentLength} 100`}
          strokeDashoffset={0}
        />
      </svg>
    </div>
  )
}

export default MiniWaveChart
